import React from "react";
import { PageQuestion } from "../types/hexpertTypes";
import {HexpertPowerRangeElementBlock} from "./HexpertPowerRangeElementBlock";
import {HexpertPressureChoiceElementBlock} from "./HexpertPressureChoiceElementBlock";
import {HexpertTemperatureChoiceBlock} from "./HexpertTemperatureChoiceBlock";
import {ParagraphTextElementBlock} from "./ParagraphTextElementBlock";
import {WeFitChoiceBlock} from "./WeFitChoiceBlock.tsx";
import {WeFitDropDownBlock} from "./WeFitDropDownBlock";
import {WeFitGraphRangeSliderBlock} from "./WeFitGraphRangeSliderBlock";
import {WeFitListItemsBlock} from "./WeFitListItemsBlock";

export type ContentTypes =
  | "WeFitChoiceElementBlock"
  | "WeFitDencityTextboxElementBlock"
  | "WeFitFlowRateTextboxElementBlock"
  | "HexpertPowerRangeElementBlock"
  | "WeFitSeparatorBlock"
  | "WeFitSpecificHeatCapacityTextboxElementBlock"
  | "WeFitStartupFrequencyTextboxElementBlock"
  | "WeFitSubmitButtonElementBlock"
  | "WeFitTextBoxElementBlock"
  | "WeFitThermalConductivityTextboxElementBlock"
  | "RangeElementBlock"
  | "HexpertIndustryChoiceElementBlock"
  | "HexpertSelectionDependentOn"
  | "HexpertTemperatureChoiceElementBlock"
  | "HexpertPressureChoiceElementBlock"
  | "WeFitPowerTextboxElementBlock"
  | "ParagraphTextElementBlock"
  | "WeFitSubmitButtonElementBlock";

export const loadComponent = (
  contentType: ContentTypes,
  content: PageQuestion,
  nextStep?: () => void
) => {
  switch (contentType) {
    case "WeFitChoiceElementBlock":
      return <WeFitChoiceBlock {...content} key={content.FieldId} />;
    case "HexpertPressureChoiceElementBlock":
      return (
        <HexpertPressureChoiceElementBlock {...content} key={content.FieldId} />
      );
    case "HexpertTemperatureChoiceElementBlock":
      return (
        <HexpertTemperatureChoiceBlock {...content} key={content.FieldId} />
      );
    case "WeFitSeparatorBlock":
      return null;
    case "RangeElementBlock":
      return <WeFitGraphRangeSliderBlock {...content} key={content.FieldId} />;
    case "HexpertPowerRangeElementBlock":
      return (
        <HexpertPowerRangeElementBlock {...content} key={content.FieldId} />
      );
    case "HexpertIndustryChoiceElementBlock":
      return (
        <WeFitListItemsBlock
          {...content}
          action={nextStep}
          key={content.FieldId}
        />
      );
    case "ParagraphTextElementBlock":
      return <ParagraphTextElementBlock {...content} key={content.FieldId} />;
    case "HexpertSelectionDependentOn":
      return <WeFitDropDownBlock {...content} key={content.FieldId} />;
    case "WeFitStartupFrequencyTextboxElementBlock":
      return null;
    case "WeFitSubmitButtonElementBlock":
      return null;

    case "WeFitTextBoxElementBlock":
      return null;
    case "WeFitThermalConductivityTextboxElementBlock":
      return null;
    default:
      return null;
  }
};
